<script>
export default {
  name: 'PageLogin',

  data() {
    return {
      loading: false,
      email: '',
      password: ''
    }
  },

  methods: {
    login() {
      this.loading = true
      this.$auth.login({
        data: {
          email: this.email.toLowerCase(),
          password: this.password
        },
        success() {
          this.loading = false
        },
        error(error) {
          this.loading = false
          this.$alert({
            type: 'danger',
            trans: 'errors.' + error.response.data.error
          })
        }
      })
    }
  }
}
</script>

<template>
  <section class="hero is-primary">
    <div class="container">
      <h1 class="title">Login</h1>

      <form class="box" @submit.prevent="login">
        <p class="field">
          <label for="email">Email</label>
          <input type="email" class="input" id="email" v-model="email">
        </p>
        <p class="field">
          <label for="password">Mot de passe</label>
          <input type="password" class="input" id="password" v-model="password">
        </p>
        <p class="field has-text-centered">
          <button class="button is-success" :class="{'is-loading': loading}">Connexion</button>
        </p>
      </form>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 640px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageLogin.vue